import { render, staticRenderFns } from "./loader.vue?vue&type=template&id=6f8a6be4&scoped=true&"
import script from "./loader.vue?vue&type=script&lang=ts&"
export * from "./loader.vue?vue&type=script&lang=ts&"
import style0 from "./loader.vue?vue&type=style&index=0&id=6f8a6be4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f8a6be4",
  null
  
)

export default component.exports